/**
 * Global concurrency limiter for camera-model screenshot operations.
 *
 * manager-api allows 16 live operations per user and store, and counts a finished one for
 * 23 minutes: "Screenshot all devices" on a big store must not burn that quota in one burst.
 */

const MAX_CONCURRENT_CAPTURES = 4;

let running = 0;
const queue = [];

function onTaskSettled() {
  running -= 1;
  pump();
}

function pump() {
  while (running < MAX_CONCURRENT_CAPTURES && queue.length > 0) {
    const { task, resolve, reject } = queue.shift();
    running += 1;
    task().then(resolve, reject).finally(onTaskSettled);
  }
}

/**
 * Run `task` as soon as an operation slot frees up.
 *
 * @param {() => Promise<*>} task - The operation to run.
 * @returns {Promise<*>} Resolves/rejects with the task's own outcome.
 */
export default function limitCapture(task) {
  return new Promise((resolve, reject) => {
    queue.push({ task, resolve, reject });
    pump();
  });
}
